import { render, staticRenderFns } from "./under-maintenance-page.html?vue&type=template&id=180630bc&scoped=true&external"
import script from "./under-maintenance-page.js?vue&type=script&lang=js&external"
export * from "./under-maintenance-page.js?vue&type=script&lang=js&external"
import style0 from "./under-maintenance-page.scss?vue&type=style&index=0&id=180630bc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180630bc",
  null
  
)

export default component.exports